import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertCircle, CheckCircle2, ChevronDown, ChevronUp, Globe2 } from "lucide-react";

export default function MissingUploadsAudit({
  missingAudit, showMissing, setShowMissing, onPrefill,
}) {
  const total = missingAudit.totalMissing;
  return (
    <Card className={`rounded-sm mb-4 ${total > 0 ? "border-amber-300 bg-amber-50/50" : "border-emerald-300 bg-emerald-50/40"}`}
      data-testid="missing-uploads-card">
      <CardContent className="p-4">
        <button
          type="button"
          onClick={() => setShowMissing(!showMissing)}
          className="w-full flex items-center justify-between gap-3 text-left"
          data-testid="missing-uploads-toggle"
        >
          <div className="flex items-center gap-3">
            {total > 0
              ? <AlertCircle className="h-5 w-5 text-amber-600" />
              : <CheckCircle2 className="h-5 w-5 text-emerald-600" />}
            <div>
              <div className="font-semibold text-sm">
                {total > 0
                  ? `${total} upload${total === 1 ? "" : "s"} missing across the last 12 completed months`
                  : "All properties × platforms are fully uploaded for the last 12 completed months"}
              </div>
              <div className="text-[11px] text-zinc-600 mt-0.5">
                Compares each property&apos;s active platforms against the last 12 completed months. The current month is excluded while still in progress.
              </div>
            </div>
          </div>
          {total > 0 && (showMissing
            ? <ChevronUp className="h-4 w-4 text-zinc-500" />
            : <ChevronDown className="h-4 w-4 text-zinc-500" />)}
        </button>

        {showMissing && total > 0 && (
          <div className="mt-4 space-y-2 max-h-72 overflow-y-auto pr-1"
            data-testid="missing-uploads-list">
            {missingAudit.rows.map((row) => (
              <div
                key={`${row.business_unit_id}-${row.platform}`}
                className="rounded-sm border border-amber-200 bg-white p-2.5"
                data-testid={`missing-row-${row.business_unit_id}-${row.platform}`}
              >
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <div className="flex items-center gap-2">
                    <Badge className="rounded-sm text-[10px] uppercase tracking-wider bg-zinc-900 text-white"
                      title={row.bu_name}>
                      <Globe2 className="h-2.5 w-2.5 mr-1" />
                      {row.bu_name}
                    </Badge>
                    <Badge variant="outline" className="rounded-sm text-[10px] uppercase tracking-wider font-mono">
                      {row.platform_label}
                    </Badge>
                  </div>
                  <span className="text-[11px] font-mono text-amber-700">
                    {row.missing_months.length} missing
                  </span>
                </div>
                <div className="mt-2 flex flex-wrap gap-1">
                  {row.missing_months.map((m) => (
                    <button
                      key={m}
                      type="button"
                      onClick={() => onPrefill(row.business_unit_id, row.platform, m)}
                      className="text-[10px] font-mono px-1.5 py-0.5 rounded-sm bg-amber-100 border border-amber-200 text-amber-900 hover:bg-amber-200 transition-colors"
                      title="Click to pre-fill the upload form with these values"
                    >
                      {m}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
